import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import UIContainer from 'components/UIContainer';
import { Box } from '../../components/vensaComponents';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from 'components/UIContainer/actions/headerActions';
import { LOADING_STATUS, useComponentDidMount } from 'libs/newHttp';
import RouteBar from 'components/DesktopComponents/RouteBar';
import TabBar from 'components/DesktopComponents/TabBar';
import { go } from 'routes';
import { useAccountStore, useMyHealthStore } from 'store/mobx/mobx';
import ExpandableCard from './components/ExpandableCard/ExpandableCard';
import Notifications from 'HealthFeed/HealthFeedDesktop/Notifications/Notifications';
import { getFinalStatus } from 'Identity/components/IdentityLabel';
import 'styles/screens.css';

const Outer = styled.div`
  width: 100%;
  background-color: #f9f9f9;
  height: 100%;
  overflow-y: auto;
  align-items: center;

  @media (--mobile) {
    overflow: auto;
    display: none;
    scrollbar-width: none;
  }

  @media (--desktop) {
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      width: 10px;
    }

    &::-webkit-scrollbar-track {
      background: #f0f0f0;
      border-radius: 25px;
      margin-left: 1rem;
    }

    &::-webkit-scrollbar-thumb {
      background: #afafaf;
      border-radius: 25px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #999;
    }
  }
`;
const Container = styled.div`
  padding: 0rem 0rem;
  display: flex;
  flex-wrap: wrap;
  margin: auto;
  width: 700px;
  padding-top: 2rem;
  margin-bottom: 5rem;
  flex-direction: column;
`;
const Column = styled.div`
  margin: auto;
  margin-top: 0;
`;
const Title = styled.div`
  font-size: 13px;
  color: #6c6c6c;
  margin: 1rem 0;
`;
interface IProps {
  setHeader: (item: string) => void;
  feed: any;
}

const LabsPage: React.FC<IProps> = observer(({ setHeader, feed }) => {
  // const { getLabResults, labResultsTab: { newInLastMonth, past }, loading, getClinicNotes, clinicalErrorText } = useMyHealthStore();
  const healthStore = useMyHealthStore();
  const store = useAccountStore();
  const [showNotes, setShowNotes] = useState(false);
  const [showDocuments, setShowDocuments] = useState(false);

  useComponentDidMount(() => {
    setHeader('PHR');
    healthStore.getLabResults();
    healthStore.getClinicNotes();
    healthStore.getPatientDocuments();
  });

  useEffect(() => {
    if (healthStore.clinicNotesTabLoadingStatus === LOADING_STATUS.LOADED) {
      if (healthStore.clinicalErrorText === null) {
        setShowNotes(true);
      }
      if (
        healthStore.clinicalErrorText !== '' &&
        healthStore.clinicalErrorText !== null
      ) {
        setShowNotes(false);
      }
    }

    if (healthStore.patientDocumentTabLoadingStatus === LOADING_STATUS.LOADED) {
      if (healthStore.documentsErrorText === null) {
        setShowDocuments(true);
        console.log('labs');
        return;
      }
      if (
        healthStore.documentsErrorText !== '' &&
        healthStore.documentsErrorText !== null
      ) {
        setShowDocuments(false);
      }
    }
  }, [
    healthStore.clinicNotesTabLoadingStatus,
    healthStore.patientDocumentTabLoadingStatus,
    healthStore.clinicalErrorText,
    healthStore.documentsErrorText,
  ]);

  return (
    <UIContainer isFetching={healthStore.loading} navKey="My Health Record">
      <Outer>
        <RouteBar lowLevel={'Labs/Results'} lowLink={() => go.LabsPage()} />
        <TabBar
          type={1}
          id={1}
          hideNotes={!showNotes}
          hideDocuments={!showDocuments}
        />
        {getFinalStatus(store) !== 1 && !store.profile.PrivacyPolicySetup && (
          <Notifications feed={feed} getFeed={() => {}} hide={() => {}} />
        )}
        <Container>
          {(healthStore.labResultsTab.past.length > 0 ||
            healthStore.labResultsTab.newInLastMonth.length > 0) && (
            <Box
              direction="column"
              borderBottom={1}
              borderColor="grey2"
              pb={2}
              color="primary"
              onClick={() => {
                healthStore.downloadLabResults();
              }}
            >
              Download All Lab Results
            </Box>
          )}
          {healthStore.labResultsTab.newInLastMonth.map(item => (
            <ExpandableCard item={item} type={'labs'} />
          ))}
          {healthStore.labResultsTab.past.length > 0 ||
          healthStore.labResultsTab.newInLastMonth.length > 0 ? (
            <Title>PREVIOUS LAB RESULTS</Title>
          ) : (
            <Title>NO LAB RESULTS FOUND</Title>
          )}
          {healthStore.labResultsTab.past.map(item => (
            <ExpandableCard item={item} type={'labs'} />
          ))}
        </Container>
      </Outer>
    </UIContainer>
  );
});

const mapStateToProps = (state: any) => ({
  feed: state.feedReducer.feed,
});

const mapDispatchToProps = (dispatch: any) => ({
  setHeader: bindActionCreators<any, any>(actions.setSideHeaderItem, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(LabsPage);
